import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { ILayerProps, ILayerStyleProps, ILayerStyles } from '/druid/Layer.types';
import { LayerBase } from '/druid/Layer.base';
import { getStyles } from '/druid/Layer.styles';

export const Layer: React.FunctionComponent<ILayerProps> = styled<ILayerProps, ILayerStyleProps, ILayerStyles>(
  LayerBase,
  getStyles,
  undefined,
  {
    scope: 'Layer',
    fields: ['hostId', 'theme', 'styles'],
  },
);
